import { GetServerSideProps } from 'next';
import { getDefautServerProps } from 'server/getDefaultServerProps';
import { withComputeEnabled } from 'hocs/withComputeEnabled';
import { ComputeDashboard } from 'modules/Compute/Dashboard/ComputeDashboard';

export const getServerSideProps: GetServerSideProps = async ({ req, params, res }) => {
  const defaultServerProps = await getDefautServerProps({ params, req, res });
  const host = req ? req.headers.host : 'clarifai.com';

  return {
    props: {
      ...defaultServerProps,
      trackEventProps: {
        eventName: 'Compute Dashboard Viewed',
      },
      host,
    },
  };
};

export default withComputeEnabled()(ComputeDashboard);
